module.exports = __webpack_public_path__ + "static/media/img_payment@2x.b55a2478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_payment@2x.png
// module id = 1062
// module chunks = 0